export default __webpack_public_path__ + "img/bg_about-26e36bcdb670380192b8d894af4b5b5c.jpg";